import React, { useEffect, useRef } from 'react';
import styles from './Popup.styles';
import Icons from '../icons/Icons';
import { VEC_ICON_NAME } from "../icons/constants";
import HoverContainer from '../hovercontainer/HoverContainer';
import { Theme } from '../constants'
import Heading from '../heading/Heading';
import { HEADING } from '../heading/constants/constants';

export default function Popup({ title, isPopupOpen = false, onCloseCb, showClose = true, children, customPopupSyles = {}, childrenStyles = {}, overlayStyles = {}, showHeader = true, customPopupHeaderStyles = {} }) {
    
    const bodyRef = useRef(document.querySelector('body'));
	useEffect(() => {
        const updatePageScroll = () => {
        if (isPopupOpen) {
            bodyRef.current.style.overflow = 'hidden';
        } else {
            bodyRef.current.style.overflow = '';
        }
        };
        updatePageScroll();
    }, [isPopupOpen]);

    return (
        <div
            style={{
                ...styles.overlay,
                visibility: isPopupOpen ? "visible" : "hidden",
                opacity: isPopupOpen ? "1" : "0",
                ...overlayStyles
            }}
        >
            <div style={{ ...styles.popup, ...customPopupSyles }}>
                {showHeader && <div style={{...styles.popupHeader, ...customPopupHeaderStyles}}>
                    <Heading type={HEADING.H2} customStyle={styles.popupHeaderTitle}>{title}</Heading>
                    {
                        showClose ?
                            <HoverContainer onClick={onCloseCb} hoverColor={Theme.HOVER_PRIMARY}>
                                <Icons familyName={'vec'} iconName={VEC_ICON_NAME.CLOSE} style={styles.closeIcon} />
                            </HoverContainer>
                            : null
                    }
                </div>}
                <div style={{ ...styles.content, ...childrenStyles }}>
                    {children}
                </div>
            </div>
        </div>
    )
}